import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toRight",
  "use": "toRight-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"toRight\">\n<path d=\"M4.29492 3.11499L8.87492 7.70499L4.29492 12.295L5.70492 13.705L11.7049 7.70499L5.70492 1.70499L4.29492 3.11499Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol